import { apiFetch, apiPost } from './api';

export async function startTaskExecution(): Promise<void> {
  await apiFetch('/user/transition_to_task_execution', { method: 'POST' });
}

export async function loadRolloutTask(payload: Record<string, unknown>) {
  // No state gate — preload before transitioning into task_execution.
  return apiPost<{ ok: boolean }>('/user/rollout/load', payload);
}

export async function unloadRolloutTask() {
  return apiPost<{ ok: boolean }>('/user/rollout/unload');
}

export async function startRolloutTask(payload?: Record<string, unknown>) {
  // Run-control endpoints live under /user/rollout/ — gated by task_execution state.
  return apiPost<{ ok: boolean; state?: string }>('/user/rollout/start', payload ?? {});
}

/** Kiosk pause never connects the leader arms. */
export async function pauseRolloutTask() {
  return apiPost<{ ok: boolean; state?: string }>('/all/rollout/pause', { arm: false });
}

export async function resumeRolloutTask() {
  return apiPost<{ ok: boolean; state?: string }>('/all/rollout/resume');
}

/** Valid in every robot state. */
export async function stopRolloutTask() {
  return apiPost<{ ok: boolean; state?: string }>('/all/rollout/stop');
}
